// extracted by mini-css-extract-plugin
module.exports = {"box":"address-module--box--19Drj"};